export default {
    nav: {
        home: 'Home',
        about: 'About Lab',
        team: 'Team',
        research: 'Research',
        resources: 'Lab Resources',
        contact: 'Contact',
        recruitment: 'Recruitment'
    },
    header: {
        labName: 'Embodied and Medical Intelligence Lab',
        labNameEn: 'Embodied and Medical Intelligence Lab',
        uestc: 'UESTC',
        uestcSz: 'UESTC (Shenzhen) Institute'
    },
    footer: {
        about: 'About Us',
        research: 'Research',
        contact: 'Contact Us',
        copyright: '© 2025 Embodied and Medical Intelligence Lab. All Rights Reserved.',
        addressInfo: 'Address: Yinxing Zhijie Phase II, No.1301-80 Guanguang Road, Xinlan Community, Guanlan Street, Longhua District, Shenzhen | Email: EMIL_Lab@126.com'
    },
    home: {
        heroTitle: 'Welcome to Embodied and Medical Intelligence Lab',
        heroSubtitle: 'Exploring Cutting-edge Technology, Creating a Better Future',
        directorContact: 'Director Contact',
        name: 'Name: ',
        title: 'Title: ',
        email: 'Email: ',
        office: 'Office: ',
        officeHours: 'Office Hours: ',
        directorName: 'Prof. Fan Zhun',
        directorTitle: 'Professor / Doctoral Supervisor',
        directorEmail: 'fanzhun@uestc.edu.cn',
        directorOffice: 'Building 2, Yinxing Zhijie Phase II, No.1301-78 Guanguang Road, Xinlan Community, Guanlan Street, Longhua District, Shenzhen',
        directorHours: 'Mon-Fri 9:00-17:00, Closed on weekends and holidays',
        notices: 'Notices',
        dailyRecommend: 'Daily Picks'
    },
    about: {
        heroTitle: 'About Lab',
        heroSubtitle: 'Learn about our history, mission and research directions',
        directorContact: 'Director Contact',
        name: 'Name: ',
        title: 'Title: ',
        email: 'Email: ',
        office: 'Office: ',
        officeHours: 'Office Hours: ',
        directorName: 'Prof. Fan',
        directorTitle: 'Professor / Doctoral Supervisor',
        directorEmail: 'fanzhun@uestc.edu.cn',
        directorOffice: 'Building 2, Yinxing Zhijie Phase II, No.1301-78 Guanguang Road, Xinlan Community, Guanlan Street, Longhua District, Shenzhen',
        directorHours: 'Mon-Fri 9:00-17:00, Closed on weekends and holidays',
        labIntro: 'Lab Introduction',
        researchDirections: 'Research Directions',
        researchIntro: 'The lab is dedicated to AI and robotics research and applications. Main research directions include:'
    },
    team: {
        heroTitle: 'Academic Team',
        heroSubtitle: 'Gathering Top Talents, Creating Research Excellence',
        professorTeam: 'Faculty Team',
        studentTeam: 'Graduate Students'
    },
    research: {
        heroTitle: 'Research Achievements',
        heroSubtitle: 'Exploring Innovation, Pursuing Excellence',
        ourAchievements: 'Our Research Achievements',
        achievementsIntro: 'The AI and Robotics Lab has achieved fruitful results in multiple research fields, including high-level academic papers, research projects, patent technologies and research awards.',
        publications: 'Publications',
        highlight: 'Highlight',
        projects: 'Projects',
        verticalProjects: 'Vertical Projects',
        horizontalProjects: 'Horizontal Projects',
        patents: 'Patents',
        softwareCopyrights: 'Software Copyrights',
        awards: 'Awards',
        videos: 'Videos',
        viewMorePapers: 'View More Papers →',
        viewMoreProjects: 'View More Projects →',
        viewMorePatents: 'View More Patents →',
        viewMoreAwards: 'View More Awards →',
        viewMoreVideos: 'View More Videos →',
        allPapersLoaded: 'All papers loaded',
        allHighlightLoaded: 'All highlight loaded',
        allProjectsLoaded: 'All projects loaded',
        allPatentsLoaded: 'All patents loaded',
        allSoftwareCopyrightsLoaded: 'All software copyrights loaded',
        allAwardsLoaded: 'All awards loaded',
        allVideosLoaded: 'All videos loaded',
        paperCover: 'Paper Cover',
        projectImage: 'Project Image',
        patentCert: 'Patent Certificate',
        softwareCopyrightCert: 'Software Copyright Certificate',
        awardCert: 'Award Certificate',
        videoCover: 'Video Cover',
        noPdf: 'No PDF file uploaded for this achievement',
        noVideo: 'No video file uploaded for this achievement',
        browserNotSupport: 'Your browser does not support video playback.'
    },
    resources: {
        heroTitle: 'Lab Resources',
        heroSubtitle: 'Experimental platforms, computing resources and robotic equipment for research and engineering practice',
        categoryTitle: 'Resource Categories',
        categoryIntro: 'Select a category to view equipment, then choose a list item to browse images and descriptions.',
        viewDetail: 'View Details →',
        empty: 'No resource data available',
        loadFailed: 'Failed to load, please try again later'
    },
    contact: {
        heroTitle: 'Contact Us',
        heroSubtitle: 'Looking Forward to Communicating with You',
        contactInfo: 'Contact Information',
        address: 'Address',
        addressDetail: 'Room 406, Building 3, Yinxing Zhijie Phase II, No.1301-80 Guanguang Road, Xinlan Community, Guanlan Street, Longhua District, Shenzhen',
        phone: 'Phone',
        phoneDetail: '+86-18066104692 (Ms. Xu)',
        emailLabel: 'Email',
        emailDetail: 'EMIL_Lab@126.com',
        officeHours: 'Office Hours',
        weekdays: 'Mon-Fri: 9:00-17:00',
        weekends: 'Closed on weekends and holidays',
        traffic: 'Transportation',
        subway: 'Metro: Line 4 Changhu Station Exit B, 20 min walk',
        bus: 'Bus: UESTC Shenzhen Institute Station (M450)',
        sendMessage: 'Send Message',
        formName: 'Name',
        formEmail: 'Email',
        formPhone: 'Phone',
        formSubject: 'Subject',
        selectSubject: 'Please select a subject',
        subjectResearch: 'Research Cooperation',
        subjectVisit: 'Visit',
        subjectInternship: 'Internship',
        subjectAdmission: 'Admission',
        subjectOther: 'Other',
        formMessage: 'Message',
        submitBtn: 'Send Message',
        submitSuccess: 'Your message has been sent!'
    },
    notice: {
        back: '< Back',
        loading: 'Loading...',
        publishTime: 'Published: ',
        fetchError: 'Failed to fetch details',
        networkError: 'Network error, please retry',
        retry: 'Retry'
    },
    teamDetail: {
        heroTitle: 'Academic Team',
        heroSubtitle: 'Gathering Top Talents, Creating Research Excellence',
        email: 'Email: ',
        office: 'Office: ',
        officeHours: 'Office Hours: ',
        education: 'Education',
        workExperience: 'Work Experience',
        researchInterests: 'Research Interests',
        publications: 'Selected Publications',
        projects: 'Research Projects',
        backToTeam: 'Back to Team'
    }
}
